import * as React from "react";
import "debounce";
import "tabbable";
import { useCurrentBreakPoint } from "../helpers/helper/hooks/use-current-breakpoint.mjs";
import { Icon } from "../icon/icon/icon.mjs";
import { Separator } from "../separator/separator.mjs";
import { TableCell } from "../table/table-cell/table-cell.mjs";
const PriceTableCell = (props) => {
  const { price, width } = props;
  const currentBreak = useCurrentBreakPoint();
  const isMobile = currentBreak === "xs" || currentBreak === "sm";
  const renderChannelPriceTableCellContent = () => {
    const priceData = price.price;
    if (priceData) {
      if ("label" in priceData) {
        if (priceData.isIncluded === true) {
          return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Icon, { modifiers: "#check", size: "xs" }), /* @__PURE__ */ React.createElement("span", { className: "sr-only" }, priceData.label));
        } else if (priceData.isIncluded === false) {
          return isMobile ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Icon, { modifiers: "#minus", size: "xs" }), /* @__PURE__ */ React.createElement("span", { className: "sr-only" }, priceData.label)) : /* @__PURE__ */ React.createElement("span", { className: "sr-only" }, priceData.label);
        } else {
          return /* @__PURE__ */ React.createElement("p", null, priceData.label);
        }
      } else {
        return /* @__PURE__ */ React.createElement(React.Fragment, null, price.label && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("p", { className: "text-small" }, price.label), /* @__PURE__ */ React.createElement(Separator, { spacing: "xxsmall", color: "invisible" })), priceData.text);
      }
    }
    return /* @__PURE__ */ React.createElement("span", null, price.label);
  };
  return /* @__PURE__ */ React.createElement(TableCell, { width, className: "text-center", valign: "middle" }, renderChannelPriceTableCellContent());
};
export {
  PriceTableCell
};
